import { render } from "./blog-text-box-new.vue?vue&type=template&id=699b7ffa&scoped=true"
import script from "./blog-text-box-new.vue?vue&type=script&lang=js"
export * from "./blog-text-box-new.vue?vue&type=script&lang=js"

import "./blog-text-box-new.vue?vue&type=style&index=0&id=699b7ffa&scoped=true&lang=css"
import "./blog-text-box-new.vue?vue&type=style&index=1&id=699b7ffa&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-699b7ffa"]])

export default __exports__